var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 6.66699H16.6667L19.1667 10.047V15.0003H17.4708C17.3718 15.6956 17.0252 16.3317 16.4947 16.7919C15.9643 17.2522 15.2856 17.5055 14.5833 17.5055C13.8811 17.5055 13.2024 17.2522 12.6719 16.7919C12.1415 16.3317 11.7949 15.6956 11.6958 15.0003H7.47084C7.37178 15.6956 7.02519 16.3317 6.49474 16.7919C5.9643 17.2522 5.28561 17.5055 4.58334 17.5055C3.88108 17.5055 3.20239 17.2522 2.67194 16.7919C2.1415 16.3317 1.79491 15.6956 1.69584 15.0003H0.833344V5.00033C0.833344 4.77931 0.921141 4.56735 1.07742 4.41107C1.2337 4.25479 1.44566 4.16699 1.66668 4.16699H13.3333C13.5544 4.16699 13.7663 4.25479 13.9226 4.41107C14.0789 4.56735 14.1667 4.77931 14.1667 5.00033V6.66699ZM14.1667 8.33366V10.8337H17.5V10.5962L15.8267 8.33366H14.1667Z",
    fill: "#B9B9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrack);
export default __webpack_public_path__ + "static/media/icon_track.d569f41db00542edcd923b4148542bdb.svg";
export { ForwardRef as ReactComponent };